// extracted by mini-css-extract-plugin
export default {"Wrapper":"ISDEIEDataExtractorCongrats_Wrapper__KlOPr","Buttons":"ISDEIEDataExtractorCongrats_Buttons__Ucf0D"};